import { useState, useCallback } from 'react';
import { TemplateForm, ValidationErrors } from '../types/index';
import { ObjectSchema } from 'yup';

export function useTemplateForm(schema: ObjectSchema<any>) {
    const [form, setForm] = useState<TemplateForm>({
        from: '',
        subject: '',
        body: '',
        allowedDomains: [],
        senderBias: '',
        contentBiases: [],
        selectedModel: undefined
    });

    const [errors, setErrors] = useState<ValidationErrors>({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const validateForm = useCallback(() => {
        try {
            schema.validateSync(form, { abortEarly: false });
            setErrors({});
            return true;
        } catch (validationError: any) {
            const newErrors: ValidationErrors = {};
            validationError.inner.forEach((error: any) => {
                newErrors[error.path as keyof ValidationErrors] = error.message;
            });
            setErrors(newErrors);
            return false;
        }
    }, [form, schema]);

    const handleChange = useCallback((field: keyof TemplateForm, value: any) => {
        setForm((prev) => ({
            ...prev,
            [field]: value
        }));
    }, []);

    return {
        form,
        setForm,
        errors,
        isSubmitting,
        setIsSubmitting,
        handleChange,
        validateForm
    };
}
